"use client"
import { useRef, useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faSearch } from '@fortawesome/free-solid-svg-icons'
import { useRouter } from 'next/navigation';
import Menu from './Header/Menu';
import TopBar from './Header/TopBar';
import { useAppUI } from '@/contexts/AppUIContext';
import { GlobalFilter } from '@/core/models/filters/globalfilter';
import { slugify } from '@/lib/slugify';
import Logo from './Header/Logo';
import Search from './Search';


export default function Header() {
  const router = useRouter();
  const { toggleMobileMenu } = useAppUI();

  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const searchRef = useRef<HTMLDivElement>(null);

  const [globalFilter, setGlobalFilter] = useState<GlobalFilter>({
    keyword: '',
  });

  // Close the search panel when the user clicks outside the search container.
  // PrimeReact dropdowns use appendTo="self" so their panels stay inside the
  // container DOM — contains() correctly keeps the panel open during selection.
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(e.target as Node)) {
        setIsSearchOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSearch = () => {
    // Build path: /spare-shops-near-me/[province]/[city]/[suburb]
    const parts: string[] = ['/spare-shops-near-me'];

    if (globalFilter.provinceName) parts.push(slugify(globalFilter.provinceName));
    if (globalFilter.cityName && globalFilter.provinceName) parts.push(slugify(globalFilter.cityName));
    if (globalFilter.suburbName && globalFilter.cityName && globalFilter.provinceName)
      parts.push(slugify(globalFilter.suburbName));

    let destination = parts.join('/');

    // Append keyword as query param
    const query: Record<string, string> = {};
    if (globalFilter.keyword) query.text = slugify(globalFilter.keyword.trim());
    const qs = new URLSearchParams(query).toString();
    if (qs) destination += `?${qs}`;

    router.push(destination);
    setIsSearchOpen(false);
  };

  return (
    <>
      <>
        <div className="top-header">
          <TopBar />
        </div>
        <div className="container">
          <div className="middle-header mb-2 flex justify-between lg:justify-end items-center h-auto xl:h-16 relative">
            <div className="logo w-[184px] h-[101px] xl:relative xl:bottom-5 2xl:absolute xl:left-0 2xl:bottom-0.5 basis-3/12 md:basis-2/12">
              <Logo />
            </div>
            <Menu />
            <div className='lg:hidden flex items-center'>
              <div className='md:hidden mr-3'>
                <FontAwesomeIcon icon={faSearch} className='text-lg' onClick={() => setIsSearchOpen(prev => !prev)} />
              </div>
              <div className=''>
                <FontAwesomeIcon icon={faBars} className='text-lg' onClick={toggleMobileMenu} />
              </div>

            </div>
          </div>
        </div>
        <div className="bottom-header">
          <div className="container">
            <div className="header-search h-12 items-center justify-end w-auto md:before:w-full before:h-full before:bottom-0 before:bg-[var(--primary-color)] 2xl:before:-right-[52%] xl:before:-right-[40%] md:before:-right-[22%] before:right-[-80px] before:w-[800px] relative z-10 skew-left flex md:flex gap-3">
              <p className='text-white text-sm pr-2 hidden lg:block'>Filter scrap yards / spares shop : </p>
              <div className='relative max-[450px]:w-full' ref={searchRef}>
                <div className='bg-white flex justify-end max-md:w-full'>
                  <input type='text' placeholder='Spare Shop, Scrap Yard, Car Parts By Location' className='text-xs px-4 py-1.5 max-[450px]:w-full w-[350px] lg:w-[300px]' onFocus={() => setIsSearchOpen(true)} value={globalFilter.keyword}
                    onChange={(e) =>
                      setGlobalFilter((prev) => ({ ...prev, keyword: e.target.value }))
                    }></input>
                  <button className='pl-3 pr-3 cursor-pointer border-l border-gray-300' title="Search" aria-label="Search" onClick={handleSearch}>
                    <FontAwesomeIcon icon={faSearch} className='text-sm text-primary' />
                  </button>
                </div>
                {isSearchOpen && <Search globalFilter={globalFilter} setGlobalFilter={setGlobalFilter} />}
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  )
}
